import { object, string } from "yup";

import IVariation, { IVariationInput } from "@/interfaces/variation.interface";
import { VariationFormMessages } from "@/messages/variation/variations-form.messages";

import { VariationFormData } from "./types";

function generateRandomCode(length: number, customerId: number): string {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let randomChars = "";
  for (let i = 0; i < length; i++) {
    randomChars += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return randomChars + customerId.toString().slice(0, 10 - length);
}

export const buildInitialData = (
  customerId: number,
  isEditing: boolean,
  variation?: IVariation | null
): VariationFormData => {
  const customerIdStr = customerId.toString();
  const codeLength = 10 - customerIdStr.length;
  const codePrefix = generateRandomCode(codeLength, customerId);

  return {
    customerId: variation?.customerId || 0,
    code: variation?.code || codePrefix + customerIdStr,
    description: variation?.description || "",
    changeDate: variation?.changeDate || null,
    changeForId: variation?.changeForId || null,
    isEditing: isEditing,
  };
};

export const buildFormPageSchema = (messages: VariationFormMessages) =>
  object().shape({
    description: string().required(messages.errorRequiredVariationDescription),
  });

export const normalizeCreationData = (formData: IVariationInput): IVariationInput => {
  const normalizedFormData: IVariationInput = {
    ...formData,
  };

  return normalizedFormData;
};

export const normalizeUpdateData = (formData: IVariationInput): IVariationInput => {
  const currentDate = new Date();

  const normalizedFormData: IVariationInput = {
    ...formData,
    changeDate: currentDate,
  };

  return normalizedFormData;
};
